export default function NotFound(): JSX.Element {
    return <h1>404 - Page Not Found</h1>;
}
